webpackJsonp([125204919682159],{

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(40);
	
	var _gatsbyLink = __webpack_require__(38);
	
	var _Typography = __webpack_require__(16);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _actions = __webpack_require__(95);
	
	var _BasicPage = __webpack_require__(70);
	
	var _BasicPage2 = _interopRequireDefault(_BasicPage);
	
	var _withRoot = __webpack_require__(71);
	
	var _withRoot2 = _interopRequireDefault(_withRoot);
	
	var _AnimateButton = __webpack_require__(94);
	
	var _AnimateButton2 = _interopRequireDefault(_AnimateButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	;
	
	
	/**
	 * Presentational component for affidavit about page
	 */
	function DisclaimerPage(_ref) {
	  var addAffidavit = _ref.addAffidavit;
	
	  var fireEvent = function fireEvent() {
	    var id = addAffidavit();
	    (0, _gatsbyLink.navigateTo)('/edit?id=' + id);
	  };
	
	  return _react2.default.createElement(
	    _BasicPage2.default,
	    {
	      heading: 'Very important!',
	      back: '/affidavits',
	      expanded: 'Affidavits',
	      selected: 'View all affidavits'
	    },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _Typography2.default,
	        { component: 'p' },
	        _react2.default.createElement(
	          'strong',
	          null,
	          'IMPORTANT: This information will NOT be used against you or given to anyone else'
	        )
	      ),
	      _react2.default.createElement(
	        _Typography2.default,
	        { component: 'p', style: { marginTop: '1rem' } },
	        'It is VERY important that you are honest when answering the questions. Please answer the questions to the best of your knowledge and with as much detail as possible.'
	      ),
	      _react2.default.createElement(
	        _Typography2.default,
	        { component: 'p', style: { marginTop: '1rem' } },
	        'If you leave important questions out because you are shy or embarrassed or say something that you know is not true, it makes it difficult for the lawyer to help you. For example, if you owe money to your landlord you must be honest by saying so and explaining why.'
	      ),
	      _react2.default.createElement(
	        _Typography2.default,
	        { component: 'p', style: { marginTop: '1rem' } },
	        'If your lawyer gets to court and puts false information in front of the judge, it will hurt your case.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { onClick: fireEvent, style: { marginTop: '3rem' } },
	        _react2.default.createElement(_AnimateButton2.default, { variant: 'contained', color: 'primary', fullWidth: true, size: 'large', text: 'I understand' })
	      )
	    )
	  );
	}
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  return _extends({}, ownProps);
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
	  return _extends({}, ownProps, {
	    addAffidavit: function addAffidavit() {
	      return dispatch((0, _actions.addAffidavit)());
	    }
	  });
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _withRoot2.default)(DisclaimerPage));
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-disclaimer-jsx-35a6ebe271696614d964.js